import { productsSliderInit } from '../sliders/sliders';
import { recommendationsInit } from '../cart/recommendations';

/**
 * Update the cart
 * @param  {String} url URL for the HTML
 * @return {Void}
 */
export const updateCart = (url) => {
  $.ajax({
    url,
    dataType: 'html',
    success(html) {
      const $html = $(html).html();

      $('.js-cart-holder').empty();
      $($html).appendTo($('.js-cart-holder'));
      productsSliderInit($('.js-cart-drawer .js-products-holder'));
    },
  });
};
